/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Settings Page of this app
 */
import { Box } from "@mui/material";
import React from "react";

const SettingsPage = () => {
  return (
    <Box display="flex" flex={1}>
      On Progress..
    </Box>
  );
};
export default SettingsPage;
